// src/data/courses.js

export const categories = [
  { id: 'programming', name: 'Programación', color: '#e94560' },
  { id: 'data', name: 'Data Science', color: '#ffc947' },
  { id: 'design', name: 'Diseño', color: '#a855f7' },
  { id: 'business', name: 'Negocios', color: '#3b82f6' },
  { id: 'social-sciences', name: 'Ciencias Sociales', color: '#10b981' },
  { id: 'tourism', name: 'Turismo', color: '#f97316' },
];

export const instructors = {
  'prof-garcia': {
    id: 'prof-garcia',
    name: 'Dra. María García',
    title: 'Profesora de Ingeniería de Software',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150',
    bio: 'PhD en Ciencias de la Computación. 15 años de experiencia docente.',
    email: 'maria.garcia@educat.edu',
  },
  'prof-mendez': {
    id: 'prof-mendez',
    name: 'Dr. Carlos Méndez',
    title: 'Profesor de Economía Política',
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150',
    bio: 'PhD en Economía. Especialista en economía política y sistemas económicos comparados. 20 años de experiencia académica.',
    email: 'carlos.mendez@educat.edu',
  },
  'prof-rivera': {
    id: 'prof-rivera',
    name: 'Mtra. Valentina Rivera',
    title: 'Profesora de Diseño Gráfico',
    avatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=150',
    bio: 'Máster en Diseño Gráfico y Comunicación Visual. Diseñadora con 12 años de experiencia en branding y diseño editorial.',
    email: 'valentina.rivera@educat.edu',
  },
  'prof-torres': {
    id: 'prof-torres',
    name: 'Dr. Alejandro Torres',
    title: 'Profesor de Emprendimiento y Turismo',
    avatar: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=150',
    bio: 'PhD en Administración de Empresas Turísticas. Consultor internacional en desarrollo turístico sostenible. Fundador de 3 startups del sector turismo. 18 años de experiencia en la industria.',
    email: 'alejandro.torres@educat.edu',
  },
};

export const contentTypes = {
  material: { label: 'Material teórico', icon: 'Description', color: '#3b82f6' },
  video: { label: 'Video clase', icon: 'PlayCircle', color: '#e94560' },
  quiz: { label: 'Cuestionario', icon: 'Quiz', color: '#ffc947' },
  activity: { label: 'Actividad', icon: 'Assignment', color: '#00d9a5' },
  exam: { label: 'Examen', icon: 'School', color: '#a855f7' },
  forum: { label: 'Foro', icon: 'Forum', color: '#6b7280' },
};

export const courses = {
  // ==========================================
  // CURSO: INTRODUCCIÓN A LA PROGRAMACIÓN
  // ==========================================
  'intro-programacion': {
    id: 'intro-programacion',
    slug: 'intro-programacion',
    title: 'Introducción a la Programación',
    subtitle: 'Fundamentos de programación con Python - Semestre 2025-1',
    description: `Curso introductorio de programación diseñado para estudiantes sin experiencia previa. Aprenderás los conceptos fundamentales de la programación utilizando Python como lenguaje principal.

**Metodología:** Clases teóricas con material de lectura, videos explicativos, ejercicios prácticos semanales, evaluaciones y proyecto integrador.

**Requisitos:** Computadora con acceso a internet. No se requiere experiencia previa.`,
    thumbnail: 'https://images.unsplash.com/photo-1526379095098-d400fd0bf935?w=800',
    category: 'programming',
    level: 'Principiante',
    instructorId: 'prof-garcia',
    price: 0,
    rating: 4.8,
    reviewsCount: 342,
    studentsCount: 1250,
    duration: '16 semanas',
    credits: 4,
    featured: true,
    grading: { quizzes: 20, activities: 30, midterm: 20, final: 20, project: 10 },
    units: [
      {
        id: 'unit-1',
        title: 'Unidad 1: Fundamentos de Programación',
        description: 'Introducción a los conceptos básicos de programación y el entorno de desarrollo.',
        contents: [
          { id: 'u1-material-1', type: 'material', title: '📖 Introducción a la programación', description: 'Material de lectura sobre qué es la programación, historia y aplicaciones.', content: { text: `# Introducción a la Programación\n\n## ¿Qué es programar?\n\nProgramar es el proceso de crear instrucciones que una computadora puede ejecutar para realizar tareas específicas.\n\n## Historia breve\n\n- **1843**: Ada Lovelace escribe el primer algoritmo\n- **1991**: Guido van Rossum crea Python\n\n## Conceptos clave\n\n- **Algoritmo**: Secuencia de pasos para resolver un problema\n- **Variable**: Espacio en memoria para almacenar datos\n- **Función**: Bloque de código reutilizable`, files: [{ name: 'Presentación Unidad 1.pdf', size: '2.4 MB', url: '#' }] }, required: true, points: 0 },
          { id: 'u1-video-1', type: 'video', title: '🎬 Video: Configuración del entorno', description: 'Aprende a instalar Python y VS Code paso a paso.', content: { videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ', duration: '25:30' }, required: true, points: 0, minWatchPercent: 90 },
          { id: 'u1-quiz-1', type: 'quiz', title: '📝 Cuestionario: Conceptos básicos', description: 'Evalúa tu comprensión de los conceptos fundamentales. 3 intentos disponibles.', content: { quizId: 'quiz-u1-conceptos', timeLimit: 20, attempts: 3, passingScore: 70 }, required: true, points: 10, dueDate: '2025-01-20' },
          { id: 'u1-activity-1', type: 'activity', title: '📤 Actividad 1: Mi primer programa', description: 'Crea tu primer programa en Python que muestre un saludo personalizado.', content: { instructions: `## Objetivo\nCrear un programa en Python que solicite el nombre del usuario y muestre un saludo personalizado.\n\n## Entregables\n- Archivo .py con el código fuente\n- Captura de pantalla de la ejecución`, acceptedFiles: ['.py', '.png', '.jpg', '.pdf', '.zip'], maxFiles: 3, maxFileSize: 10 }, required: true, points: 15, dueDate: '2025-01-27' },
        ],
      },
      {
        id: 'unit-2',
        title: 'Unidad 2: Variables y Tipos de Datos',
        description: 'Aprende sobre variables, tipos de datos y operadores en Python.',
        contents: [
          { id: 'u2-material-1', type: 'material', title: '📖 Variables y tipos de datos', description: 'Material teórico sobre variables, tipos de datos primitivos y conversiones.', content: { text: `# Variables y Tipos de Datos en Python\n\n## Variables\n\nUna variable es un contenedor para almacenar datos:\n\n\`\`\`python\nnombre = "Ana"\nedad = 25\n\`\`\``, files: [{ name: 'Unidad 2 - Presentación.pdf', size: '3.1 MB', url: '#' }] }, required: true, points: 0 },
          { id: 'u2-video-1', type: 'video', title: '🎬 Video: Variables en acción', description: 'Demostración práctica del uso de variables y operadores.', content: { videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ', duration: '32:15' }, required: true, points: 0, minWatchPercent: 90 },
          { id: 'u2-quiz-1', type: 'quiz', title: '📝 Cuestionario: Variables y operadores', description: 'Evalúa tu conocimiento sobre variables. 2 intentos.', content: { quizId: 'quiz-u2-variables', timeLimit: 25, attempts: 2, passingScore: 70 }, required: true, points: 10, dueDate: '2025-02-10' },
          { id: 'u2-activity-1', type: 'activity', title: '📤 Actividad 2: Calculadora básica', description: 'Desarrolla una calculadora que realice las 4 operaciones básicas.', content: { instructions: `## Objetivo\nCrear una calculadora en Python que permita realizar operaciones básicas.`, acceptedFiles: ['.py', '.pdf', '.png', '.zip'], maxFiles: 5, maxFileSize: 15 }, required: true, points: 20, dueDate: '2025-02-20' },
        ],
      },
      {
        id: 'unit-3',
        title: 'Unidad 3: Estructuras de Control',
        description: 'Condicionales, bucles y control de flujo del programa.',
        contents: [
          { id: 'u3-material-1', type: 'material', title: '📖 Condicionales y bucles', description: 'Estructuras if/else, while y for en Python.', content: { text: `# Estructuras de Control\n\n## Condicionales\n\n\`\`\`python\nif edad >= 18:\n    print("Adulto")\nelse:\n    print("Menor")\n\`\`\``, files: [{ name: 'Unidad 3 - Slides.pdf', size: '2.8 MB', url: '#' }] }, required: true, points: 0 },
          { id: 'u3-video-1', type: 'video', title: '🎬 Video: Condicionales', description: 'Explicación de if, elif y else con ejemplos.', content: { videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ', duration: '28:00' }, required: true, points: 0, minWatchPercent: 90 },
          { id: 'u3-quiz-1', type: 'quiz', title: '📝 Cuestionario: Estructuras de control', description: 'Evalúa tu comprensión de condicionales y bucles.', content: { quizId: 'quiz-u3-control', timeLimit: 30, attempts: 2, passingScore: 70 }, required: true, points: 10, dueDate: '2025-03-03' },
          { id: 'u3-activity-1', type: 'activity', title: '📤 Actividad 3: Juego de adivinanza', description: 'Crea un juego donde el usuario debe adivinar un número aleatorio.', content: { instructions: `## Objetivo\nDesarrollar un juego de adivinanza usando estructuras de control.`, acceptedFiles: ['.py', '.mp4', '.mov', '.zip'], maxFiles: 3, maxFileSize: 50 }, required: true, points: 25, dueDate: '2025-03-13' },
          { id: 'u3-exam-1', type: 'exam', title: '🎓 Examen Parcial', description: 'Evaluación de las unidades 1, 2 y 3. Solo 1 intento.', content: { quizId: 'exam-parcial', timeLimit: 60, attempts: 1, passingScore: 60 }, required: true, points: 100, dueDate: '2025-03-16' },
        ],
      },
      {
        id: 'unit-4',
        title: 'Unidad 4: Funciones y Proyecto Final',
        description: 'Creación de funciones y proyecto integrador.',
        contents: [
          { id: 'u4-material-1', type: 'material', title: '📖 Funciones en Python', description: 'Todo sobre la creación y uso de funciones.', content: { text: `# Funciones en Python\n\n## Sintaxis básica\n\n\`\`\`python\ndef saludar(nombre):\n    return f"¡Hola, {nombre}!"\n\`\`\``, files: [{ name: 'Unidad 4 - Funciones.pdf', size: '2.2 MB', url: '#' }] }, required: true, points: 0 },
          { id: 'u4-video-1', type: 'video', title: '🎬 Video: Creando funciones', description: 'Aprende a crear funciones efectivas.', content: { videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ', duration: '40:00' }, required: true, points: 0, minWatchPercent: 90 },
          { id: 'u4-quiz-1', type: 'quiz', title: '📝 Cuestionario: Funciones', description: 'Demuestra tu conocimiento sobre funciones.', content: { quizId: 'quiz-u4-funciones', timeLimit: 25, attempts: 2, passingScore: 70 }, required: true, points: 10, dueDate: '2025-03-24' },
          { id: 'u4-activity-1', type: 'activity', title: '📤 PROYECTO FINAL: Sistema de Biblioteca', description: 'Desarrolla un sistema completo aplicando todo lo aprendido.', content: { instructions: `## Proyecto Final: Sistema de Gestión de Biblioteca\n\n### Funcionalidades requeridas\n- Agregar, buscar, listar y eliminar libros\n- Gestión de préstamos`, acceptedFiles: ['.py', '.zip', '.pdf', '.mp4', '.mov'], maxFiles: 6, maxFileSize: 100 }, required: true, points: 50, dueDate: '2025-04-03' },
          { id: 'u4-exam-final', type: 'exam', title: '🎓 Examen Final', description: 'Evaluación integral de todo el curso. Solo 1 intento.', content: { quizId: 'exam-final', timeLimit: 90, attempts: 1, passingScore: 60 }, required: true, points: 100, dueDate: '2025-04-06' },
        ],
      },
    ],
  },

  // ==========================================
  // CURSO: ECONOMÍA POLÍTICA
  // ==========================================
  'economia-politica': {
    id: 'economia-politica',
    slug: 'economia-politica',
    title: 'Fundamentos de Economía Política',
    subtitle: 'Análisis de sistemas económicos y relaciones de poder - Semestre 2025-1',
    description: `Curso introductorio de economía política que explora la relación entre economía, política y sociedad. Analizarás los principales sistemas económicos, teorías del valor, distribución de la riqueza y el papel del Estado en la economía.

**Metodología:** Lecturas teóricas, videos explicativos, análisis de casos reales, debates y ensayos críticos.

**Requisitos:** No se requiere experiencia previa en economía.`,
    thumbnail: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=800',
    category: 'social-sciences',
    level: 'Principiante',
    instructorId: 'prof-mendez',
    price: 0,
    rating: 4.7,
    reviewsCount: 218,
    studentsCount: 890,
    duration: '16 semanas',
    credits: 4,
    featured: true,
    grading: { quizzes: 20, activities: 30, midterm: 20, final: 20, project: 10 },
    units: [
      {
        id: 'ep-unit-1',
        title: 'Unidad 1: Introducción a la Economía Política',
        description: 'Conceptos fundamentales, origen histórico y objeto de estudio.',
        contents: [
          { id: 'ep-u1-material-1', type: 'material', title: '📖 ¿Qué es la Economía Política?', description: 'Fundamentos y origen de la economía política.', content: { text: `# Introducción a la Economía Política\n\n## ¿Qué es la Economía Política?\n\nLa economía política estudia las relaciones entre economía y política, analizando cómo las estructuras de poder influyen en la producción y distribución.\n\n## Conceptos fundamentales\n\n- **Modo de producción**: Forma en que una sociedad organiza la producción\n- **Plusvalía**: Diferencia entre valor producido y salario pagado\n- **Acumulación de capital**: Proceso de reinversión de ganancias`, files: [{ name: 'Introducción Economía Política.pdf', size: '2.8 MB', url: '#' }] }, required: true, points: 0 },
          { id: 'ep-u1-video-1', type: 'video', title: '🎬 Video: Historia del pensamiento económico', description: 'Recorrido por las principales escuelas de pensamiento.', content: { videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ', duration: '35:00' }, required: true, points: 0, minWatchPercent: 90 },
          { id: 'ep-u1-quiz-1', type: 'quiz', title: '📝 Cuestionario: Conceptos básicos', description: 'Evalúa tu comprensión de los fundamentos. 3 intentos.', content: { quizId: 'ep-quiz-u1-conceptos', timeLimit: 20, attempts: 3, passingScore: 70 }, required: true, points: 10, dueDate: '2025-01-20' },
          { id: 'ep-u1-activity-1', type: 'activity', title: '📤 Actividad 1: Análisis comparativo', description: 'Compara las visiones de Adam Smith y Karl Marx sobre el valor.', content: { instructions: `## Objetivo\nElaborar un ensayo comparativo entre las teorías del valor de Adam Smith y Karl Marx.\n\n## Requisitos\n- Extensión: 800-1200 palabras\n- Citar al menos 2 fuentes académicas`, acceptedFiles: ['.pdf', '.doc', '.docx'], maxFiles: 2, maxFileSize: 10 }, required: true, points: 15, dueDate: '2025-01-27' },
        ],
      },
      {
        id: 'ep-unit-2',
        title: 'Unidad 2: Sistemas Económicos',
        description: 'Análisis comparativo de capitalismo, socialismo y economías mixtas.',
        contents: [
          { id: 'ep-u2-material-1', type: 'material', title: '📖 Sistemas económicos comparados', description: 'Diferentes sistemas de organización económica.', content: { text: `# Sistemas Económicos\n\n## Capitalismo\n- Propiedad privada de los medios de producción\n- Libre mercado\n- Trabajo asalariado\n\n## Socialismo\n- Propiedad social/estatal\n- Planificación centralizada\n\n## Economías mixtas\n- Combinan elementos de mercado y planificación`, files: [{ name: 'Sistemas Económicos.pdf', size: '3.5 MB', url: '#' }] }, required: true, points: 0 },
          { id: 'ep-u2-video-1', type: 'video', title: '🎬 Video: Capitalismo - orígenes y evolución', description: 'Historia del sistema capitalista.', content: { videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ', duration: '40:00' }, required: true, points: 0, minWatchPercent: 90 },
          { id: 'ep-u2-quiz-1', type: 'quiz', title: '📝 Cuestionario: Sistemas económicos', description: 'Evalúa tu conocimiento sobre los diferentes sistemas.', content: { quizId: 'ep-quiz-u2-sistemas', timeLimit: 25, attempts: 2, passingScore: 70 }, required: true, points: 10, dueDate: '2025-02-10' },
          { id: 'ep-u2-activity-1', type: 'activity', title: '📤 Actividad 2: Análisis de caso', description: 'Analiza el modelo económico de un país.', content: { instructions: `## Objetivo\nAnalizar el sistema económico de un país específico (China, Suecia, EE.UU. o Cuba).`, acceptedFiles: ['.pdf', '.doc', '.docx', '.pptx'], maxFiles: 3, maxFileSize: 20 }, required: true, points: 20, dueDate: '2025-02-20' },
        ],
      },
      {
        id: 'ep-unit-3',
        title: 'Unidad 3: El Estado y la Economía',
        description: 'Política fiscal, monetaria y el debate sobre la intervención estatal.',
        contents: [
          { id: 'ep-u3-material-1', type: 'material', title: '📖 El rol del Estado en la economía', description: 'Perspectivas sobre la intervención estatal.', content: { text: `# El Estado y la Economía\n\n## Política Fiscal\n- Impuestos\n- Gasto público\n- Transferencias sociales\n\n## Política Monetaria\n- Tasa de interés\n- Encaje bancario\n- Emisión monetaria\n\n## Debates: Keynes vs Hayek`, files: [{ name: 'Estado y Economía.pdf', size: '2.9 MB', url: '#' }] }, required: true, points: 0 },
          { id: 'ep-u3-video-1', type: 'video', title: '🎬 Video: Política fiscal explicada', description: 'Cómo funcionan los impuestos y el gasto público.', content: { videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ', duration: '32:00' }, required: true, points: 0, minWatchPercent: 90 },
          { id: 'ep-u3-quiz-1', type: 'quiz', title: '📝 Cuestionario: Estado y economía', description: 'Evalúa tu comprensión sobre política económica.', content: { quizId: 'ep-quiz-u3-estado', timeLimit: 30, attempts: 2, passingScore: 70 }, required: true, points: 10, dueDate: '2025-03-03' },
          { id: 'ep-u3-activity-1', type: 'activity', title: '📤 Actividad 3: Debate estructurado', description: 'Participa en un debate sobre intervención estatal.', content: { instructions: `## Objetivo\nPreparar argumentos para un debate sobre la intervención del Estado en la economía.`, acceptedFiles: ['.pdf', '.doc', '.docx', '.mp4', '.mov'], maxFiles: 4, maxFileSize: 100 }, required: true, points: 25, dueDate: '2025-03-13' },
          { id: 'ep-u3-exam-1', type: 'exam', title: '🎓 Examen Parcial', description: 'Evaluación de las unidades 1, 2 y 3. Solo 1 intento.', content: { quizId: 'ep-exam-parcial', timeLimit: 60, attempts: 1, passingScore: 60 }, required: true, points: 100, dueDate: '2025-03-16' },
        ],
      },
      {
        id: 'ep-unit-4',
        title: 'Unidad 4: Economía Política Contemporánea',
        description: 'Globalización, desigualdad, crisis y desafíos actuales.',
        contents: [
          { id: 'ep-u4-material-1', type: 'material', title: '📖 Desafíos económicos del siglo XXI', description: 'Principales problemas económicos actuales.', content: { text: `# Economía Política Contemporánea\n\n## Globalización económica\n- Integración de mercados financieros\n- Cadenas globales de producción\n\n## Desigualdad económica\n- Coeficiente de Gini\n- Concentración de riqueza\n\n## Crisis de 2008\n- Burbuja inmobiliaria\n- Derivados financieros`, files: [{ name: 'Economía siglo XXI.pdf', size: '3.2 MB', url: '#' }] }, required: true, points: 0 },
          { id: 'ep-u4-video-1', type: 'video', title: '🎬 Video: La crisis de 2008 explicada', description: 'Causas, desarrollo y consecuencias.', content: { videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ', duration: '42:00' }, required: true, points: 0, minWatchPercent: 90 },
          { id: 'ep-u4-quiz-1', type: 'quiz', title: '📝 Cuestionario: Economía contemporánea', description: 'Evalúa tu conocimiento sobre temas actuales.', content: { quizId: 'ep-quiz-u4-contemporanea', timeLimit: 25, attempts: 2, passingScore: 70 }, required: true, points: 10, dueDate: '2025-03-24' },
          { id: 'ep-u4-activity-1', type: 'activity', title: '📤 PROYECTO FINAL: Análisis de problemática económica', description: 'Investigación profunda sobre un tema de economía política actual.', content: { instructions: `## Proyecto Final\nInvestigación sobre una problemática contemporánea: desigualdad, cambio climático, automatización, etc.`, acceptedFiles: ['.pdf', '.doc', '.docx', '.pptx', '.mp4', '.mov'], maxFiles: 6, maxFileSize: 150 }, required: true, points: 50, dueDate: '2025-04-03' },
          { id: 'ep-u4-exam-final', type: 'exam', title: '🎓 Examen Final', description: 'Evaluación integral de todo el curso. Solo 1 intento.', content: { quizId: 'ep-exam-final', timeLimit: 90, attempts: 1, passingScore: 60 }, required: true, points: 100, dueDate: '2025-04-06' },
        ],
      },
    ],
  },

  // ==========================================
  // CURSO: DISEÑO BÁSICO
  // ==========================================
  'diseno-basico': {
    id: 'diseno-basico',
    slug: 'diseno-basico',
    title: 'Fundamentos del Diseño Gráfico',
    subtitle: 'Principios visuales y comunicación gráfica - Semestre 2025-1',
    description: `Curso introductorio de diseño gráfico que te enseñará los fundamentos visuales esenciales. Aprenderás sobre elementos del diseño, teoría del color, tipografía, composición y herramientas digitales básicas.

**Metodología:** Material teórico ilustrado, videos tutoriales, ejercicios prácticos de diseño y proyecto integrador.

**Requisitos:** Computadora con acceso a internet. Se recomienda instalar Canva (gratuito) o Figma.`,
    thumbnail: 'https://images.unsplash.com/photo-1561070791-2526d30994b5?w=800',
    category: 'design',
    level: 'Principiante',
    instructorId: 'prof-rivera',
    price: 0,
    rating: 4.9,
    reviewsCount: 189,
    studentsCount: 720,
    duration: '16 semanas',
    credits: 4,
    featured: true,
    grading: { quizzes: 20, activities: 30, midterm: 20, final: 20, project: 10 },
    units: [
      {
        id: 'db-unit-1',
        title: 'Unidad 1: Elementos del Diseño',
        description: 'Introducción a los elementos básicos: punto, línea, forma, color, textura y espacio.',
        contents: [
          { id: 'db-u1-material-1', type: 'material', title: '📖 Los elementos fundamentales del diseño', description: 'Bloques constructivos del diseño visual.', content: { text: `# Elementos del Diseño\n\n## Los 6 elementos básicos\n\n### 1. Punto\nEl elemento más simple, marca una posición en el espacio.\n\n### 2. Línea\nConexión entre dos puntos. Puede ser recta, curva, gruesa, delgada.\n- Horizontal: calma, estabilidad\n- Vertical: fuerza, elegancia\n- Diagonal: dinamismo, acción\n\n### 3. Forma\nÁrea definida por líneas o color.\n- Geométricas: círculos, cuadrados\n- Orgánicas: formas naturales\n\n### 4. Color\nEl elemento más expresivo, transmite emociones.\n\n### 5. Textura\nCualidad táctil visual de una superficie.\n\n### 6. Espacio\nÁrea dentro y alrededor de los elementos.\n- Espacio positivo vs negativo`, files: [{ name: 'Elementos del Diseño.pdf', size: '4.2 MB', url: '#' }] }, required: true, points: 0 },
          { id: 'db-u1-video-1', type: 'video', title: '🎬 Video: Introducción al diseño gráfico', description: 'Historia breve y campos de aplicación.', content: { videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ', duration: '28:00' }, required: true, points: 0, minWatchPercent: 90 },
          { id: 'db-u1-video-2', type: 'video', title: '🎬 Video: Punto, línea y forma en acción', description: 'Demostración práctica de los elementos básicos.', content: { videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ', duration: '35:00' }, required: true, points: 0, minWatchPercent: 90 },
          { id: 'db-u1-quiz-1', type: 'quiz', title: '📝 Cuestionario: Elementos del diseño', description: 'Evalúa tu comprensión de los elementos básicos. 3 intentos.', content: { quizId: 'db-quiz-u1-elementos', timeLimit: 20, attempts: 3, passingScore: 70 }, required: true, points: 10, dueDate: '2025-01-20' },
          { id: 'db-u1-activity-1', type: 'activity', title: '📤 Actividad 1: Composición con elementos básicos', description: 'Crea una composición abstracta usando solo punto, línea y forma.', content: { instructions: `## Objetivo\nCrear una composición visual abstracta utilizando únicamente los elementos básicos del diseño.\n\n## Requisitos\n1. Usar solo punto, línea y forma\n2. Formato: cuadrado (1080x1080 px)\n3. Máximo 3 colores\n\n## Entregables\n- Archivo de imagen (PNG o JPG)\n- Breve descripción (100 palabras) del concepto`, acceptedFiles: ['.png', '.jpg', '.jpeg', '.pdf'], maxFiles: 2, maxFileSize: 15 }, required: true, points: 15, dueDate: '2025-01-27' },
        ],
      },
      {
        id: 'db-unit-2',
        title: 'Unidad 2: Principios del Diseño',
        description: 'Balance, contraste, énfasis, movimiento, patrón, ritmo y unidad.',
        contents: [
          { id: 'db-u2-material-1', type: 'material', title: '📖 Los 7 principios del diseño', description: 'Cómo organizar los elementos visuales.', content: { text: `# Principios del Diseño\n\n## 1. Balance (Equilibrio)\n- Simétrico: elementos iguales a ambos lados\n- Asimétrico: equilibrio con elementos diferentes\n- Radial: desde un centro\n\n## 2. Contraste\nDiferencia entre elementos para crear interés visual.\n\n## 3. Énfasis (Punto focal)\nCrear jerarquía visual para guiar la atención.\n\n## 4. Movimiento\nGuiar el ojo del espectador a través del diseño.\n\n## 5. Patrón\nRepetición de elementos de forma organizada.\n\n## 6. Ritmo\nVariación dentro de la repetición.\n\n## 7. Unidad\nCohesión entre todos los elementos.`, files: [{ name: 'Principios del Diseño.pdf', size: '5.1 MB', url: '#' }] }, required: true, points: 0 },
          { id: 'db-u2-video-1', type: 'video', title: '🎬 Video: Balance y contraste', description: 'Cómo crear equilibrio e interés visual.', content: { videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ', duration: '32:00' }, required: true, points: 0, minWatchPercent: 90 },
          { id: 'db-u2-video-2', type: 'video', title: '🎬 Video: Jerarquía y movimiento visual', description: 'Guía para dirigir la atención del espectador.', content: { videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ', duration: '28:00' }, required: true, points: 0, minWatchPercent: 90 },
          { id: 'db-u2-quiz-1', type: 'quiz', title: '📝 Cuestionario: Principios del diseño', description: 'Demuestra tu conocimiento sobre los principios. 2 intentos.', content: { quizId: 'db-quiz-u2-principios', timeLimit: 25, attempts: 2, passingScore: 70 }, required: true, points: 10, dueDate: '2025-02-10' },
          { id: 'db-u2-activity-1', type: 'activity', title: '📤 Actividad 2: Rediseño de póster', description: 'Aplica los principios para mejorar un diseño existente.', content: { instructions: `## Objetivo\nRediseñar un póster mal diseñado aplicando los principios aprendidos.\n\n## Entregables\n1. Imagen del diseño original\n2. Tu rediseño\n3. Documento explicativo con análisis`, acceptedFiles: ['.png', '.jpg', '.pdf', '.doc', '.docx'], maxFiles: 4, maxFileSize: 20 }, required: true, points: 20, dueDate: '2025-02-20' },
        ],
      },
      {
        id: 'db-unit-3',
        title: 'Unidad 3: Color y Tipografía',
        description: 'Teoría del color, psicología cromática, familias tipográficas y legibilidad.',
        contents: [
          { id: 'db-u3-material-1', type: 'material', title: '📖 Teoría del color para diseñadores', description: 'Círculo cromático, armonías y psicología del color.', content: { text: `# Teoría del Color\n\n## El círculo cromático\n- Primarios: Rojo, Amarillo, Azul\n- Secundarios: Naranja, Verde, Violeta\n\n## Propiedades del color\n- Tono (Hue): El color puro\n- Saturación: Intensidad\n- Valor: Claridad u oscuridad\n\n## Armonías\n- Monocromática: Un solo color\n- Complementaria: Colores opuestos\n- Análoga: Colores adyacentes\n- Triádica: Tres colores equidistantes\n\n## Psicología del color\n- 🔴 Rojo: Pasión, energía\n- 🔵 Azul: Confianza, calma\n- 🟡 Amarillo: Alegría, optimismo\n- 🟢 Verde: Naturaleza, salud`, files: [{ name: 'Teoría del Color.pdf', size: '6.2 MB', url: '#' }] }, required: true, points: 0 },
          { id: 'db-u3-material-2', type: 'material', title: '📖 Fundamentos de tipografía', description: 'Familias tipográficas, anatomía de las letras y reglas de uso.', content: { text: `# Fundamentos de Tipografía\n\n## Clasificación de fuentes\n\n### Serif (con serifa)\nTimes New Roman, Georgia, Garamond\n- Uso: Textos largos impresos\n\n### Sans-serif (sin serifa)\nArial, Helvetica, Roboto\n- Uso: Pantallas, web\n\n### Display / Decorativas\nImpact, Lobster\n- Uso: Títulos, logos\n\n### Script / Manuscritas\nPacifico, Dancing Script\n- Uso: Invitaciones, elegancia\n\n## Reglas de oro\n1. Máximo 2-3 fuentes por proyecto\n2. Contraste entre fuentes\n3. Jerarquía tipográfica clara`, files: [{ name: 'Guía de Tipografía.pdf', size: '4.5 MB', url: '#' }] }, required: true, points: 0 },
          { id: 'db-u3-video-1', type: 'video', title: '🎬 Video: Dominando el color', description: 'Tutorial práctico sobre paletas y armonías.', content: { videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ', duration: '38:00' }, required: true, points: 0, minWatchPercent: 90 },
          { id: 'db-u3-video-2', type: 'video', title: '🎬 Video: Tipografía que comunica', description: 'Cómo elegir y combinar fuentes.', content: { videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ', duration: '42:00' }, required: true, points: 0, minWatchPercent: 90 },
          { id: 'db-u3-quiz-1', type: 'quiz', title: '📝 Cuestionario: Color y tipografía', description: 'Evalúa tu conocimiento sobre color y fuentes.', content: { quizId: 'db-quiz-u3-color-tipo', timeLimit: 30, attempts: 2, passingScore: 70 }, required: true, points: 10, dueDate: '2025-03-03' },
          { id: 'db-u3-activity-1', type: 'activity', title: '📤 Actividad 3: Moodboard de marca', description: 'Crea un moodboard con paleta de colores y tipografía para una marca ficticia.', content: { instructions: `## Objetivo\nDesarrollar el sistema visual básico para una marca ficticia.\n\n## Entregables\n1. Moodboard (tablero de inspiración)\n2. Paleta de colores con códigos HEX\n3. Sistema tipográfico\n4. Documento explicativo`, acceptedFiles: ['.png', '.jpg', '.pdf', '.doc', '.docx'], maxFiles: 5, maxFileSize: 30 }, required: true, points: 25, dueDate: '2025-03-13' },
          { id: 'db-u3-exam-1', type: 'exam', title: '🎓 Examen Parcial', description: 'Evaluación de las unidades 1, 2 y 3. Solo 1 intento.', content: { quizId: 'db-exam-parcial', timeLimit: 60, attempts: 1, passingScore: 60 }, required: true, points: 100, dueDate: '2025-03-16' },
        ],
      },
      {
        id: 'db-unit-4',
        title: 'Unidad 4: Composición y Proyecto Final',
        description: 'Grids, layouts, diseño responsivo y proyecto integrador.',
        contents: [
          { id: 'db-u4-material-1', type: 'material', title: '📖 Composición y layouts', description: 'Sistemas de grillas, regla de tercios y layouts.', content: { text: `# Composición y Layouts\n\n## Regla de tercios\nDivide el espacio en 9 partes iguales. Los puntos de intersección son ideales para elementos importantes.\n\n## Sistemas de grillas (Grid)\n\n### Tipos de grid:\n- Grid de manuscrito: Una sola columna\n- Grid de columnas: 2, 3, 4 o más columnas\n- Grid modular: Columnas + filas\n- Grid jerárquico: Basado en el contenido\n\n## Espacio en blanco\nMejora la legibilidad y crea elegancia.\n\n## Patrones de lectura\n- Patrón F: Para texto\n- Patrón Z: Para páginas simples`, files: [{ name: 'Composición y Grids.pdf', size: '5.8 MB', url: '#' }] }, required: true, points: 0 },
          { id: 'db-u4-video-1', type: 'video', title: '🎬 Video: Grids y layouts profesionales', description: 'Cómo usar sistemas de grillas.', content: { videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ', duration: '45:00' }, required: true, points: 0, minWatchPercent: 90 },
          { id: 'db-u4-quiz-1', type: 'quiz', title: '📝 Cuestionario: Composición', description: 'Evalúa tu conocimiento sobre layouts y grillas.', content: { quizId: 'db-quiz-u4-composicion', timeLimit: 25, attempts: 2, passingScore: 70 }, required: true, points: 10, dueDate: '2025-03-24' },
          { id: 'db-u4-activity-1', type: 'activity', title: '📤 PROYECTO FINAL: Identidad visual completa', description: 'Desarrolla la identidad visual básica para una marca.', content: { instructions: `## Proyecto Final: Sistema de Identidad Visual\n\n### Entregables obligatorios\n\n1. Logo (versión principal, horizontal, monocromática)\n2. Paleta de colores (códigos HEX, RGB, CMYK)\n3. Sistema tipográfico\n4. Aplicaciones (tarjeta, post Instagram, banner)\n5. Manual de marca básico (PDF)\n\n### Evaluación\n- Coherencia visual: 25%\n- Aplicación de principios: 25%\n- Creatividad: 20%\n- Calidad técnica: 15%\n- Documentación: 15%`, acceptedFiles: ['.zip', '.pdf', '.png', '.jpg'], maxFiles: 5, maxFileSize: 100 }, required: true, points: 50, dueDate: '2025-04-03' },
          { id: 'db-u4-exam-final', type: 'exam', title: '🎓 Examen Final', description: 'Evaluación integral de todo el curso. Solo 1 intento.', content: { quizId: 'db-exam-final', timeLimit: 90, attempts: 1, passingScore: 60 }, required: true, points: 100, dueDate: '2025-04-06' },
        ],
      },
    ],
  },

  // ==========================================
  // CURSO: EMPRENDIMIENTO APLICADO A TURISMO
  // ==========================================
  'emprendimiento-turismo': {
    id: 'emprendimiento-turismo',
    slug: 'emprendimiento-turismo',
    title: 'Emprendimiento Aplicado a Turismo',
    subtitle: 'Crea y gestiona tu empresa turística exitosa - Semestre 2025-1',
    description: `Curso integral que combina los fundamentos del emprendimiento con las particularidades del sector turístico. Aprenderás a identificar oportunidades de negocio, desarrollar modelos de negocio innovadores, crear planes de empresa y gestionar emprendimientos turísticos sostenibles.

**Metodología:** Casos de estudio reales, análisis de mercado, desarrollo de plan de negocios, mentoría con emprendedores del sector y proyecto integrador con evaluación por jurado.

**Requisitos:** Interés en el sector turístico. No se requiere experiencia previa en negocios.

**Proyecto Final:** Desarrollo completo de un plan de negocios turístico presentable ante inversionistas.`,
    thumbnail: 'https://images.unsplash.com/photo-1488646953014-85cb44e25828?w=800',
    category: 'tourism',
    level: 'Principiante',
    instructorId: 'prof-torres',
    price: 0,
    rating: 4.9,
    reviewsCount: 189,
    studentsCount: 567,
    duration: '16 semanas',
    credits: 4,
    featured: true,
    grading: { quizzes: 15, activities: 25, midterm: 15, final: 15, project: 30 },
    units: [
      // ========================================
      // UNIDAD 1: FUNDAMENTOS DEL EMPRENDIMIENTO TURÍSTICO
      // ========================================
      {
        id: 'et-unit-1',
        title: 'Unidad 1: Fundamentos del Emprendimiento Turístico',
        description: 'Introducción al ecosistema turístico, tipos de emprendimientos y mentalidad emprendedora.',
        contents: [
          {
            id: 'et-u1-material-1',
            type: 'material',
            title: '📖 El ecosistema del turismo y el emprendimiento',
            description: 'Panorama completo del sector turístico y las oportunidades para emprendedores.',
            content: {
              text: `# Fundamentos del Emprendimiento Turístico

## 1. El Sector Turístico Global

El turismo es una de las industrias más grandes del mundo, representando aproximadamente el **10% del PIB global** y generando 1 de cada 10 empleos a nivel mundial.

### Cifras clave (pre-pandemia y recuperación):
- **1.5 billones de dólares** en ingresos anuales por turismo internacional
- **330 millones** de empleos directos e indirectos
- Crecimiento anual promedio del **4-5%** en las últimas décadas

## 2. Tipos de Turismo

### Por motivación:
- **Turismo de ocio**: Vacaciones, descanso, entretenimiento
- **Turismo de negocios**: Congresos, convenciones, viajes corporativos
- **Turismo cultural**: Patrimonio, museos, eventos culturales
- **Turismo de aventura**: Deportes extremos, naturaleza activa
- **Turismo de salud**: Wellness, spa, turismo médico
- **Turismo gastronómico**: Rutas culinarias, experiencias foodie
- **Ecoturismo**: Turismo sostenible y de naturaleza
- **Turismo rural**: Agroturismo, experiencias campestres

## 3. La Cadena de Valor Turística

\`\`\`
ORIGEN → TRANSPORTE → DESTINO → SERVICIOS → EXPERIENCIA
   │          │           │          │            │
Agencias   Aerolíneas   Hoteles   Restaurantes  Tours
DMCs       Buses        Hostels   Actividades   Guías
OTAs       Rent-a-car   Airbnb    Comercios     Eventos
\`\`\`

## 4. Mentalidad Emprendedora

### Características del emprendedor turístico exitoso:
1. **Pasión por el servicio**: El turismo es 100% experiencia del cliente
2. **Adaptabilidad**: El sector cambia constantemente (tecnología, tendencias, crisis)
3. **Visión global, acción local**: Pensar en turistas internacionales, operar localmente
4. **Resiliencia**: Superar temporadas bajas, crisis y competencia
5. **Creatividad**: Diferenciarse en un mercado saturado
6. **Sostenibilidad**: Equilibrar rentabilidad con responsabilidad ambiental y social

## 5. Tendencias Actuales en Turismo

- **Turismo experiencial**: "Vivir como un local"
- **Bleisure**: Combinación de viajes de negocios y ocio
- **Turismo sostenible**: Carbono neutral, impacto positivo
- **Digitalización**: Reservas online, experiencias virtuales, IA
- **Personalización**: Viajes a medida, nichos específicos
- **Workcation**: Trabajo remoto + vacaciones
- **Turismo de bienestar**: Salud mental, desconexión digital`,
              files: [
                { name: 'Panorama Turismo Global 2024.pdf', size: '5.2 MB', url: '#' },
                { name: 'Infografía Cadena de Valor.pdf', size: '1.8 MB', url: '#' },
              ],
            },
            required: true,
            points: 0,
          },
          {
            id: 'et-u1-video-1',
            type: 'video',
            title: '🎬 Video: Historias de emprendedores turísticos exitosos',
            description: 'Casos reales de emprendimientos turísticos en Latinoamérica: desde hostels hasta tour operadores.',
            content: {
              videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
              duration: '38:00',
            },
            required: true,
            points: 0,
            minWatchPercent: 90,
          },
          {
            id: 'et-u1-quiz-1',
            type: 'quiz',
            title: '📝 Cuestionario: Fundamentos del turismo',
            description: 'Evalúa tu comprensión del ecosistema turístico y los tipos de emprendimientos. 3 intentos disponibles.',
            content: {
              quizId: 'et-quiz-u1-fundamentos',
              timeLimit: 20,
              attempts: 3,
              passingScore: 70,
            },
            required: true,
            points: 10,
            dueDate: '2025-01-20',
          },
          {
            id: 'et-u1-activity-1',
            type: 'activity',
            title: '📤 Actividad 1: Análisis de un emprendimiento turístico local',
            description: 'Investiga y analiza un emprendimiento turístico de tu región.',
            content: {
              instructions: `## Objetivo
Identificar y analizar en profundidad un emprendimiento turístico exitoso de tu ciudad o región.

## Requisitos del análisis:

### 1. Información general (1 página)
- Nombre del emprendimiento
- Tipo de turismo que atiende
- Año de fundación
- Historia de cómo surgió

### 2. Modelo de negocio (1-2 páginas)
- ¿Qué servicios ofrece?
- ¿Quiénes son sus clientes principales?
- ¿Cómo genera ingresos?
- ¿Qué lo diferencia de la competencia?

### 3. Factores de éxito (1 página)
- ¿Por qué crees que ha sido exitoso?
- ¿Qué desafíos ha enfrentado?
- ¿Qué harías diferente si fueras el dueño?

### Entregables:
- Documento PDF (3-4 páginas)
- Mínimo 3 fotos del establecimiento o sus servicios
- Si es posible, entrevista breve con el fundador o gerente

## Rúbrica de evaluación:
- Profundidad del análisis: 40%
- Calidad de la investigación: 30%
- Presentación y redacción: 20%
- Creatividad y propuestas: 10%`,
              acceptedFiles: ['.pdf', '.doc', '.docx', '.png', '.jpg', '.zip'],
              maxFiles: 5,
              maxFileSize: 20,
            },
            required: true,
            points: 15,
            dueDate: '2025-01-27',
          },
        ],
      },

      // ========================================
      // UNIDAD 2: ANÁLISIS DE MERCADO Y OPORTUNIDADES
      // ========================================
      {
        id: 'et-unit-2',
        title: 'Unidad 2: Análisis de Mercado y Oportunidades',
        description: 'Técnicas de investigación de mercado, identificación de oportunidades y análisis de la competencia.',
        contents: [
          {
            id: 'et-u2-material-1',
            type: 'material',
            title: '📖 Investigación de mercado en turismo',
            description: 'Metodologías y herramientas para analizar el mercado turístico.',
            content: {
              text: `# Análisis de Mercado Turístico

## 1. Investigación de Mercado

### ¿Por qué investigar?
- Reducir el riesgo de fracaso
- Identificar oportunidades no atendidas
- Conocer a tu competencia
- Entender las necesidades del cliente

### Tipos de investigación:

#### Investigación primaria:
- **Encuestas**: Google Forms, SurveyMonkey
- **Entrevistas**: Con turistas, operadores, expertos
- **Observación**: Visitar destinos, analizar comportamiento
- **Focus groups**: Grupos de discusión con clientes potenciales
- **Mystery shopping**: Evaluar competencia de incógnito

#### Investigación secundaria:
- Reportes de OMT (Organización Mundial del Turismo)
- Estadísticas de migración y turismo
- Estudios de cámaras de turismo
- Datos de aeropuertos y hoteles
- Análisis de tendencias en redes sociales

## 2. Segmentación del Mercado Turístico

### Por demografía:
| Segmento | Características | Oportunidades |
|----------|-----------------|---------------|
| Millennials | Experiencias únicas, bajo presupuesto | Hostels, tours alternativos |
| Gen Z | Nativos digitales, sostenibilidad | Eco-lodges, experiencias Instagram |
| Familias | Seguridad, comodidad, actividades | Resorts, parques temáticos |
| Seniors | Comodidad, cultura, salud | Cruceros, turismo termal |
| LGBTQ+ | Destinos friendly, eventos | Pride travel, bodas |
| Nómadas digitales | WiFi, estancias largas, comunidad | Coworking hotels, coliving |

### Por motivación de viaje:
- Descanso y relax
- Aventura y adrenalina
- Cultura y aprendizaje
- Conexión espiritual
- Romance y celebración
- Negocios y networking

## 3. Análisis de Competencia

### Modelo de las 5 Fuerzas de Porter aplicado a turismo:

\`\`\`
              NUEVOS COMPETIDORES
              (Baja barrera en turismo)
                      ↓
PROVEEDORES → RIVALIDAD ACTUAL ← CLIENTES
(Aerolíneas,    (Alta en destinos   (Alto poder:
hoteles)         populares)          comparan online)
                      ↑
               SUSTITUTOS
          (Staycation, virtual tours)
\`\`\`

### Herramientas de análisis:
- **Google Trends**: Búsquedas de destinos y servicios
- **TripAdvisor**: Reviews de competencia
- **SimilarWeb**: Tráfico web de competidores
- **Redes sociales**: Engagement y contenido
- **Booking/Airbnb**: Precios y disponibilidad

## 4. Identificación de Oportunidades

### Framework PESTEL para turismo:
- **Político**: Visas, incentivos, regulaciones
- **Económico**: Tipo de cambio, inflación, poder adquisitivo
- **Social**: Tendencias de viaje, demografía
- **Tecnológico**: Apps, realidad virtual, IA
- **Ecológico**: Sostenibilidad, cambio climático
- **Legal**: Licencias, seguros, normativas

### Océanos azules en turismo:
- Nichos no atendidos
- Combinaciones innovadoras de servicios
- Nuevas tecnologías aplicadas
- Destinos emergentes
- Experiencias personalizadas`,
              files: [
                { name: 'Plantilla Análisis de Mercado.xlsx', size: '450 KB', url: '#' },
                { name: 'Guía de Investigación Primaria.pdf', size: '2.1 MB', url: '#' },
              ],
            },
            required: true,
            points: 0,
          },
          {
            id: 'et-u2-video-1',
            type: 'video',
            title: '🎬 Video: Cómo identificar oportunidades de negocio en turismo',
            description: 'Técnicas prácticas para encontrar nichos de mercado y oportunidades desatendidas.',
            content: {
              videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
              duration: '42:00',
            },
            required: true,
            points: 0,
            minWatchPercent: 90,
          },
          {
            id: 'et-u2-quiz-1',
            type: 'quiz',
            title: '📝 Cuestionario: Análisis de mercado',
            description: 'Evalúa tu comprensión de las técnicas de investigación y análisis de mercado. 2 intentos.',
            content: {
              quizId: 'et-quiz-u2-mercado',
              timeLimit: 25,
              attempts: 2,
              passingScore: 70,
            },
            required: true,
            points: 10,
            dueDate: '2025-02-10',
          },
          {
            id: 'et-u2-activity-1',
            type: 'activity',
            title: '📤 Actividad 2: Estudio de mercado para tu idea de negocio',
            description: 'Realiza una investigación de mercado preliminar para una idea de emprendimiento turístico.',
            content: {
              instructions: `## Objetivo
Realizar un estudio de mercado básico para validar una idea de emprendimiento turístico.

## Paso 1: Define tu idea de negocio turístico
- ¿Qué tipo de servicio o producto turístico quieres ofrecer?
- ¿A qué tipo de turistas se dirige?
- ¿En qué ubicación operaría?

## Paso 2: Investigación de mercado
### Investigación primaria (mínimo 10 encuestas):
- Diseña un cuestionario de 10-15 preguntas
- Aplícalo a potenciales clientes
- Analiza los resultados

### Investigación secundaria:
- Busca estadísticas del sector
- Identifica tendencias relevantes
- Analiza reportes de turismo de tu región

## Paso 3: Análisis de competencia
- Identifica 3-5 competidores directos
- Analiza sus fortalezas y debilidades
- Encuentra tu diferenciación

## Paso 4: Conclusiones
- ¿Es viable tu idea?
- ¿Qué ajustes harías?
- ¿Cuál es la oportunidad específica?

## Entregables:
1. Documento de análisis (5-7 páginas)
2. Cuestionario utilizado
3. Datos tabulados de encuestas
4. Matriz de competencia

## Formato: PDF o Word`,
              acceptedFiles: ['.pdf', '.doc', '.docx', '.xlsx', '.zip'],
              maxFiles: 4,
              maxFileSize: 15,
            },
            required: true,
            points: 20,
            dueDate: '2025-02-20',
          },
        ],
      },

      // ========================================
      // UNIDAD 3: MODELO DE NEGOCIO Y PLAN DE EMPRESA
      // ========================================
      {
        id: 'et-unit-3',
        title: 'Unidad 3: Modelo de Negocio y Plan de Empresa',
        description: 'Canvas de modelo de negocio, propuesta de valor, estructura de costos y plan financiero.',
        contents: [
          {
            id: 'et-u3-material-1',
            type: 'material',
            title: '📖 Diseño del modelo de negocio turístico',
            description: 'Metodología Canvas aplicada al sector turístico y estructura del plan de negocios.',
            content: {
              text: `# Modelo de Negocio para Emprendimientos Turísticos

## 1. Business Model Canvas

El Canvas es una herramienta visual para diseñar modelos de negocio:

\`\`\`
┌─────────────────┬─────────────────┬─────────────────┐
│ SOCIOS CLAVE    │ ACTIVIDADES     │ PROPUESTA DE    │
│                 │ CLAVE           │ VALOR           │
│ • Proveedores   │ • Diseño tours  │                 │
│ • Alianzas      │ • Reservas      │ "Experiencias   │
│ • Distribuidores│ • Servicio      │  únicas y       │
│                 │                 │  auténticas"    │
├─────────────────┼─────────────────┤                 │
│ RECURSOS CLAVE  │                 │                 │
│                 │                 │                 │
│ • Guías         │                 │                 │
│ • Vehículos     │                 │                 │
│ • Licencias     │                 │                 │
├─────────────────┴─────────────────┼─────────────────┤
│ ESTRUCTURA DE COSTOS              │ FUENTES DE      │
│                                   │ INGRESOS        │
│ • Fijos: Alquiler, salarios       │                 │
│ • Variables: Comisiones, insumos  │ • Tours         │
│                                   │ • Reservas      │
│                                   │ • Comisiones    │
└───────────────────────────────────┴─────────────────┘
\`\`\`

## 2. Propuesta de Valor en Turismo

### Fórmula de la propuesta de valor:
**"Ayudamos a [SEGMENTO] a [BENEFICIO] mediante [SOLUCIÓN], a diferencia de [COMPETENCIA]"**

### Ejemplos:
- "Ayudamos a **familias con niños pequeños** a **viajar sin estrés** mediante **paquetes todo incluido con servicio de niñera**, a diferencia de agencias tradicionales que no consideran las necesidades específicas de los padres."

- "Ayudamos a **nómadas digitales** a **trabajar mientras viajan** mediante **espacios de coworking en destinos turísticos con buena conexión**, a diferencia de hostels que no ofrecen espacios de trabajo adecuados."

## 3. Estructura de Costos en Turismo

### Costos fijos típicos:
| Concepto | Rango mensual |
|----------|---------------|
| Alquiler local | Variable por zona |
| Salarios fijos | Según país/región |
| Seguros | 2-5% de ingresos |
| Licencias | Anual |
| Marketing básico | 5-10% de ingresos |
| Software/sistemas | $50-500 USD |

### Costos variables:
- Comisiones a guías
- Transporte
- Alimentación
- Entradas y tickets
- Comisiones OTAs (15-25%)
- Materiales/insumos

## 4. Fuentes de Ingreso

### Modelos de monetización en turismo:

1. **Venta directa**: Tours, paquetes, hospedaje
2. **Comisiones**: Referidos, afiliados
3. **Freemium**: Servicio básico gratis + premium
4. **Suscripción**: Membresías de viajero
5. **Marketplace**: Conectar oferta y demanda
6. **Publicidad**: Contenido patrocinado
7. **Licenciamiento**: Franquicias, know-how

## 5. Plan Financiero Básico

### Proyección de ventas (ejemplo tour operador):

| Mes | Tours | Precio promedio | Ingresos |
|-----|-------|-----------------|----------|
| 1-3 | 20/mes | $100 | $2,000 |
| 4-6 | 40/mes | $100 | $4,000 |
| 7-9 | 60/mes | $100 | $6,000 |
| 10-12 | 80/mes | $100 | $8,000 |

### Punto de equilibrio:
\`\`\`
Punto de equilibrio = Costos Fijos / (Precio - Costo Variable)
\`\`\`

### Indicadores clave (KPIs):
- **Ocupación**: % de capacidad utilizada
- **ADR**: Tarifa promedio diaria
- **RevPAR**: Ingreso por habitación disponible
- **CAC**: Costo de adquisición de cliente
- **LTV**: Valor del cliente en su vida útil
- **NPS**: Net Promoter Score (satisfacción)`,
              files: [
                { name: 'Plantilla Canvas Turismo.pdf', size: '1.5 MB', url: '#' },
                { name: 'Modelo Financiero Excel.xlsx', size: '890 KB', url: '#' },
                { name: 'Guía Plan de Negocios Turístico.pdf', size: '3.4 MB', url: '#' },
              ],
            },
            required: true,
            points: 0,
          },
          {
            id: 'et-u3-video-1',
            type: 'video',
            title: '🎬 Video: Cómo crear un plan de negocios turístico ganador',
            description: 'Paso a paso para desarrollar un plan de negocios que convenza a inversionistas.',
            content: {
              videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
              duration: '55:00',
            },
            required: true,
            points: 0,
            minWatchPercent: 90,
          },
          {
            id: 'et-u3-quiz-1',
            type: 'quiz',
            title: '📝 Cuestionario: Modelos de negocio',
            description: 'Evalúa tu comprensión del Canvas y los componentes del plan de negocios. 2 intentos.',
            content: {
              quizId: 'et-quiz-u3-modelo',
              timeLimit: 30,
              attempts: 2,
              passingScore: 70,
            },
            required: true,
            points: 10,
            dueDate: '2025-03-03',
          },
          {
            id: 'et-u3-activity-1',
            type: 'activity',
            title: '📤 Actividad 3: Canvas y proyección financiera',
            description: 'Desarrolla el Canvas y una proyección financiera básica para tu emprendimiento.',
            content: {
              instructions: `## Objetivo
Diseñar el modelo de negocio completo usando Canvas y crear una proyección financiera a 12 meses.

## Parte 1: Business Model Canvas
Completa cada uno de los 9 bloques:
1. Segmentos de clientes
2. Propuesta de valor
3. Canales
4. Relación con clientes
5. Fuentes de ingresos
6. Recursos clave
7. Actividades clave
8. Socios clave
9. Estructura de costos

## Parte 2: Proyección Financiera
### Incluir:
- Inversión inicial necesaria
- Costos fijos mensuales
- Costos variables por servicio
- Proyección de ventas (12 meses)
- Cálculo del punto de equilibrio
- Flujo de caja proyectado

## Parte 3: Propuesta de valor
Redacta tu propuesta de valor siguiendo la fórmula:
"Ayudamos a [SEGMENTO] a [BENEFICIO] mediante [SOLUCIÓN]"

## Entregables:
1. Canvas completo (usar plantilla)
2. Excel con proyección financiera
3. Documento explicativo (2-3 páginas)

## Criterios de evaluación:
- Coherencia del modelo: 30%
- Viabilidad financiera: 30%
- Propuesta de valor clara: 25%
- Presentación: 15%`,
              acceptedFiles: ['.pdf', '.doc', '.docx', '.xlsx', '.pptx', '.zip'],
              maxFiles: 5,
              maxFileSize: 20,
            },
            required: true,
            points: 25,
            dueDate: '2025-03-13',
          },
          {
            id: 'et-u3-exam-1',
            type: 'exam',
            title: '🎓 Examen Parcial',
            description: 'Evaluación de las unidades 1, 2 y 3. Incluye análisis de caso. Solo 1 intento.',
            content: {
              quizId: 'et-exam-parcial',
              timeLimit: 60,
              attempts: 1,
              passingScore: 60,
            },
            required: true,
            points: 100,
            dueDate: '2025-03-16',
          },
        ],
      },

      // ========================================
      // UNIDAD 4: MARKETING DIGITAL Y GESTIÓN SOSTENIBLE
      // ========================================
      {
        id: 'et-unit-4',
        title: 'Unidad 4: Marketing Digital y Gestión Sostenible',
        description: 'Estrategias de marketing digital para turismo, redes sociales, sostenibilidad y proyecto final.',
        contents: [
          {
            id: 'et-u4-material-1',
            type: 'material',
            title: '📖 Marketing digital para emprendimientos turísticos',
            description: 'Estrategias de promoción, redes sociales, SEO y publicidad para turismo.',
            content: {
              text: `# Marketing Digital en Turismo

## 1. El Viaje del Cliente Digital

### Customer Journey en turismo:
\`\`\`
SOÑAR → PLANIFICAR → RESERVAR → EXPERIMENTAR → COMPARTIR
  │         │            │            │              │
Inspiración Comparación  Conversión   Servicio     Advocacy
Instagram   TripAdvisor  Booking      In-situ      Reviews
Pinterest   Google       WhatsApp     Atención     UGC
TikTok      Blogs        OTA          Sorpresas    Referidos
\`\`\`

## 2. Presencia Digital Esencial

### Canales prioritarios para turismo:

| Canal | Uso principal | Inversión |
|-------|---------------|-----------|
| Sitio web | Base digital, reservas | Alta |
| Google My Business | Visibilidad local | Baja |
| Instagram | Inspiración visual | Media |
| Facebook | Comunidad, anuncios | Media |
| TikTok | Alcance orgánico, Gen Z | Baja |
| WhatsApp Business | Atención, ventas | Baja |
| Email marketing | Retención, ofertas | Media |
| OTAs | Distribución, visibilidad | Alta (comisiones) |

## 3. Estrategia de Contenidos

### Tipos de contenido que funcionan en turismo:
1. **Fotos profesionales**: Inversión fundamental
2. **Videos cortos**: Reels, TikToks, Stories
3. **User Generated Content (UGC)**: Reviews, fotos de clientes
4. **Behind the scenes**: Humaniza la marca
5. **Guías y tips**: Posicionamiento SEO
6. **Testimoniales**: Prueba social

### Calendario de contenidos:
- **Diario**: Stories, interacción
- **3x semana**: Posts de feed
- **Semanal**: Video/Reel de mayor producción
- **Mensual**: Blog post SEO
- **Trimestral**: Campañas especiales

## 4. SEO para Turismo

### Palabras clave típicas:
- [Actividad] + [Destino]: "tours en Cartagena"
- "Mejores [servicio] en [lugar]"
- "[Destino] qué hacer"
- "[Tipo turismo] [país/ciudad]"

### Optimización básica:
- Google My Business completo
- Web mobile-friendly
- Velocidad de carga
- Contenido local relevante
- Reviews positivos

## 5. Publicidad Digital

### Plataformas recomendadas:
- **Google Ads**: Intent alto, búsquedas específicas
- **Meta Ads (FB/IG)**: Segmentación demográfica, lookalikes
- **TikTok Ads**: Alcance, awareness
- **Remarketing**: Recuperar visitantes

### Métricas clave:
- **CPM**: Costo por mil impresiones
- **CPC**: Costo por clic
- **CTR**: Tasa de clics
- **CPA**: Costo por adquisición
- **ROAS**: Retorno sobre inversión publicitaria

## 6. Turismo Sostenible

### Los 3 pilares de la sostenibilidad:
1. **Ambiental**: Reducir huella de carbono, conservar recursos
2. **Social**: Beneficiar comunidades locales, preservar cultura
3. **Económico**: Viabilidad a largo plazo, distribución justa

### Prácticas sostenibles:
- Proveedores locales
- Reducción de plásticos
- Educación ambiental
- Empleo local
- Certificaciones (Rainforest Alliance, B Corp)
- Compensación de carbono

### Comunicar sostenibilidad:
- Transparencia en prácticas
- Certificaciones visibles
- Historias de impacto
- Involucrar al turista

## 7. Gestión de la Reputación Online

### Manejo de reviews:
- Responder TODAS las reviews (positivas y negativas)
- Agradecer específicamente
- Resolver problemas públicamente
- Invitar a volver
- Nunca ser defensivo

### Ejemplo de respuesta a review negativa:
"Gracias por tu feedback, [nombre]. Lamentamos que la experiencia no cumplió tus expectativas. Hemos tomado medidas para [acción específica]. Nos encantaría tener la oportunidad de compensarte. Por favor contáctanos a [email]."`,
              files: [
                { name: 'Plantilla Calendario de Contenidos.xlsx', size: '320 KB', url: '#' },
                { name: 'Guía de Respuesta a Reviews.pdf', size: '1.2 MB', url: '#' },
                { name: 'Checklist Sostenibilidad Turística.pdf', size: '980 KB', url: '#' },
              ],
            },
            required: true,
            points: 0,
          },
          {
            id: 'et-u4-video-1',
            type: 'video',
            title: '🎬 Video: Estrategias de marketing digital que funcionan en turismo',
            description: 'Casos de éxito y tácticas probadas para promocionar emprendimientos turísticos.',
            content: {
              videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
              duration: '48:00',
            },
            required: true,
            points: 0,
            minWatchPercent: 90,
          },
          {
            id: 'et-u4-quiz-1',
            type: 'quiz',
            title: '📝 Cuestionario: Marketing digital y sostenibilidad',
            description: 'Evalúa tu conocimiento sobre estrategias de marketing y prácticas sostenibles. 2 intentos.',
            content: {
              quizId: 'et-quiz-u4-marketing',
              timeLimit: 25,
              attempts: 2,
              passingScore: 70,
            },
            required: true,
            points: 10,
            dueDate: '2025-03-24',
          },
          {
            id: 'et-u4-activity-1',
            type: 'activity',
            title: '📤 PROYECTO FINAL: Plan de Negocios Turístico Completo',
            description: 'Desarrolla un plan de negocios completo para tu emprendimiento turístico, listo para presentar a inversionistas.',
            content: {
              instructions: `## 🏆 PROYECTO FINAL: Plan de Negocios Turístico

### Objetivo
Crear un plan de negocios profesional y completo para un emprendimiento turístico, que incluya todos los elementos necesarios para presentarlo ante inversionistas o instituciones de financiamiento.

---

## ESTRUCTURA DEL PLAN (25-35 páginas)

### 1. Resumen Ejecutivo (2 páginas)
- Concepto del negocio
- Propuesta de valor
- Mercado objetivo
- Proyecciones financieras clave
- Inversión requerida y uso de fondos

### 2. Descripción del Negocio (3 páginas)
- Misión, visión y valores
- Tipo de emprendimiento turístico
- Ubicación y alcance geográfico
- Servicios/productos ofrecidos
- Diferenciación competitiva

### 3. Análisis de Mercado (5 páginas)
- Análisis del sector turístico (local/nacional)
- Segmentación y mercado objetivo
- Tamaño del mercado y tendencias
- Análisis de competencia
- Análisis FODA

### 4. Modelo de Negocio (3 páginas)
- Business Model Canvas completo
- Propuesta de valor detallada
- Fuentes de ingreso
- Estrategia de precios

### 5. Plan de Marketing (4 páginas)
- Estrategia de posicionamiento
- Mix de marketing (4Ps)
- Plan de marketing digital
- Estrategia de contenidos
- Presupuesto de marketing

### 6. Plan Operativo (4 páginas)
- Procesos clave
- Recursos necesarios
- Proveedores y alianzas
- Tecnología requerida
- Plan de sostenibilidad

### 7. Organización y Equipo (2 páginas)
- Estructura organizacional
- Perfiles clave
- Plan de contratación

### 8. Plan Financiero (5 páginas)
- Inversión inicial detallada
- Proyección de ingresos (3 años)
- Proyección de gastos
- Estado de resultados proyectado
- Flujo de caja
- Punto de equilibrio
- Indicadores financieros (ROI, VAN, TIR)

### 9. Análisis de Riesgos (2 páginas)
- Identificación de riesgos
- Plan de mitigación
- Plan de contingencia

### 10. Anexos
- Encuestas realizadas
- Cotizaciones de proveedores
- Material gráfico del concepto
- CVs del equipo emprendedor

---

## ENTREGABLES

1. **Documento del Plan de Negocios** (PDF)
2. **Modelo Financiero en Excel** (con fórmulas)
3. **Presentación ejecutiva** (10-15 slides para pitch)
4. **Video pitch** (3-5 minutos presentando el proyecto)

---

## CRITERIOS DE EVALUACIÓN

| Criterio | Peso |
|----------|------|
| Viabilidad del concepto | 20% |
| Calidad del análisis de mercado | 15% |
| Solidez del modelo de negocio | 15% |
| Realismo financiero | 20% |
| Plan de marketing | 10% |
| Sostenibilidad | 10% |
| Presentación y profesionalismo | 10% |

---

## FECHAS IMPORTANTES
- **Avance 1 (Resumen + Mercado)**: 1 semana antes
- **Entrega final**: Fecha límite
- **Presentación ante jurado**: Por confirmar

---

¡Este proyecto puede ser el inicio de tu emprendimiento real! 🚀`,
              acceptedFiles: ['.pdf', '.doc', '.docx', '.xlsx', '.pptx', '.mp4', '.mov', '.zip'],
              maxFiles: 8,
              maxFileSize: 200,
            },
            required: true,
            points: 50,
            dueDate: '2025-04-03',
          },
          {
            id: 'et-u4-exam-final',
            type: 'exam',
            title: '🎓 Examen Final',
            description: 'Evaluación integral de todo el curso. Incluye preguntas teóricas y análisis de caso. Solo 1 intento.',
            content: {
              quizId: 'et-exam-final',
              timeLimit: 90,
              attempts: 1,
              passingScore: 60,
            },
            required: true,
            points: 100,
            dueDate: '2025-04-06',
          },
        ],
      },
    ],
  },
};



export const getCourseInstructor = (course) => instructors[course?.instructorId];
export const getFeaturedCourses = () => Object.values(courses).filter(c => c.featured);
export const getCourseBySlug = (slug) => Object.values(courses).find(c => c.slug === slug);

export const getAllContents = (course) => {
  if (!course?.units) return [];
  return course.units.flatMap(unit => 
    unit.contents.map(content => ({
      ...content,
      unitId: unit.id,
      unitTitle: unit.title,
    }))
  );
};

export const getTotalPoints = (course) => {
  return getAllContents(course).reduce((sum, c) => sum + (c.points || 0), 0);
};